import Node from 'ln/node/Node';
import LernVideo from './LernVideo';
import PlayButton from './controls/PlayButton';
import TimeDisplay from './controls/TimeDisplay';
import ProgressBar from './controls/ProgressBar';
import VolumeBar from './controls/VolumeBar';
import MuteButton from './controls/MuteButton';
import FullscreenButton from './controls/FullscreenButton';
import ChapterControl from './controls/ChapterControl';

export function play( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-play', function( n:Node, lv:LernVideo ){
        return new PlayButton( lv.player ).render( n ); 
    });
}

export function time( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-time', function( n:Node, lv:LernVideo ){
        return new TimeDisplay( lv.player ).render( n ); 
    });
}

export function progress( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-progress', function( n:Node, lv:LernVideo ){
        return new ProgressBar( lv.player ).render( n ); 
    });
}

export function volume( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-volume', function( n:Node, lv:LernVideo ){
        return new VolumeBar( lv.player ).render( n ); 
    });
}

export function mute( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-mute', function( n:Node, lv:LernVideo ){
        return new MuteButton( lv.player ).render( n ); 
    });
}

export function fullscreen( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-fullscreen', function( n:Node, lv:LernVideo ){
        return new FullscreenButton( lv.node ).render( n ); 
    });
}

export function chaptercontrol( lv:LernVideo ) {
    lv.scanner.ioc.add( 'video-chapter-control', function( n:Node, lv:LernVideo ){
        return new ChapterControl( lv.player ).render( n ); 
    });
}


export function all( lv:LernVideo ){
    play( lv );
    time( lv );
    progress( lv );
    volume( lv );
    mute( lv );
    fullscreen( lv );
    chaptercontrol( lv );

}